<template>
    <v-container fluid align-start ma-0 pa-2 class="hycot401-main container-height">
        <v-row no-gutters fill-height>
            <v-col cols="12">
                <i-card-vertical :headerTitle="menuTitle">
                    <template v-slot:body>
                        <v-row>
                            <v-col cols="12" class="pa-0">
                                <i-card-top class="d-md-flex" outlined>
                                    <!-- :useBtnList="[
                      'btnSearch'
                    ]"
                    @btnSearch="btnSearch()" -->
                                    <template v-slot:body>
                                        <v-row no-gutters class="center pa-2">
                                            <i-label :label="'Material Division : '" />
                                            <v-col cols="2">
                                                <v-select v-model="selectedMat" :items="matList" return-object
                                                    item-text="codeName" item-value="code" single-line outlined dense
                                                    height="32" @change="btnSearch" />
                                            </v-col>

                                            <i-label :label="'Receive : '" class="pl-2" />
                                            <v-col cols="2">
                                                <v-select v-model="selectedRcv" :items="rcvList" return-object
                                                    item-text="codeName" item-value="code" single-line outlined dense
                                                    height="32" @change="btnSearch" />
                                            </v-col>

                                            <i-label :label="'Submit : '" class="pl-2" />
                                            <v-col cols="2">
                                                <v-select v-model="selectedSbm" :items="sbmList" return-object
                                                    item-text="codeName" item-value="code" single-line outlined dense
                                                    height="32" @change="btnSearch" />
                                            </v-col>
                                        </v-row>
                                    </template>
                                </i-card-top>
                            </v-col>
                        </v-row>

                        <v-row no-gutters class="pt-1">
                            <v-col cols="12" class="pa-0">
                                <DxDataGrid class="listBox" :ref="hycot401Ref" :data-source="dataList"
                                    :remote-operations="false" :hover-state-enabled="true" :allow-column-resizing="true"
                                    :allow-column-reordering="true" :row-alternation-enabled="true" :show-borders="true"
                                    :width="grid.width" :show-row-lines="true" key-expr="id" :focused-row-enabled="true"
                                    :column-hiding-enabled="false" :selection="{ mode: 'none' }" :word-wrap-enabled="true">
                                    <DxColumn data-field="id" caption="No" width="3%" data-type="string" alignment="center"
                                        :visible="true" :allow-editing="false" />
                                    <DxColumn data-field="quotNo" caption="Quotation No" width="8%" data-type="string"
                                        alignment="center" :visible="true" cell-template="quotNoTemplate"
                                        :allow-editing="false" />
                                    <template #quotNoTemplate="{ data }">
                                        <v-btn small elevation="0" color="transparent" class="px-1 py-0 grd-btn"
                                            @click="goDetail(data)">
                                            {{ data.value }}
                                        </v-btn>
                                    </template>
                                    <DxColumn data-field="quotTitle" caption="Title" data-type="string" alignment="left"
                                        :visible="true" cell-template="quotTitleTemplate" :allow-editing="false" />
                                    <template #quotTitleTemplate="{ data }">
                                        <!-- <v-btn small elevation="0" color="transparent" class="px-1 py-0 grd-btn" @click="goDetail(data)" >
                        {{ data.value }}
                      </v-btn> -->
                                        <fragment>
                                            <span class="text-hover bold-hover cursor-pointer" @click.stop="goDetail(data)">
                                                {{ data.value }}
                                            </span>
                                             <b v-if="data.data.quotStep !== 'C1'" style="color: #0000ff;">
                                                {{ data.data.quotStep === 'C2' ? '1st re-Bidding' : (data.data.quotStep === 'C3' ? '2nd re-Bidding' : data.data.quotStep === 'C4' ? '3rd re_Bidding' : '') }}
                                             </b>
                                        </fragment>
                                    </template>
                                    <DxColumn data-field="startDte" caption="Start Time" width="8%" data-type="string"
                                        alignment="center" :visible="true" :allow-editing="false" />
                                    <DxColumn data-field="finishDte" caption="Finish Time" width="8%" data-type="string"
                                        alignment="center" :visible="true" :allow-editing="false" />
                                    <DxColumn data-field="receiveYn" caption="Recieve" width="6%" alignment="center"
                                        :visible="true" cell-template="recieveTemplate" :allow-editing="false" />
                                    <template #recieveTemplate="{ data }">
                                        <template v-if="data.value === 'Y'">
                                            <v-icon small class="mt-n1" color="blue">
                                                mdi-checkbox-marked-circle
                                            </v-icon>
                                        </template>
                                        <template v-else>
                                            <v-btn small elevation="0" color="transparent" class="px-1 py-0 grd-btn"
                                                @click.stop="receiveQuot(data.data)">
                                                <v-icon small class="mt-n1">
                                                    mdi-arrow-right-box
                                                </v-icon>
                                                Recieve
                                            </v-btn>
                                        </template>
                                    </template>
                                    <DxColumn data-field="submitYn" caption="Submit" width="6%" data-type="string"
                                        alignment="center" :visible="true" cell-template="submitTemplate"
                                        :allow-editing="false" />
                                    <template #submitTemplate="{ data }">
                                        <template v-if="data.value === 'Y'">
                                            <v-icon small class="mt-n1" color="blue">
                                                mdi-checkbox-marked-circle
                                            </v-icon>
                                        </template>
                                        <template v-else>
                                            <v-btn small elevation="0" color="transparent" class="px-1 py-0 grd-btn"
                                                @click.stop="goDetail(data)">

                                                <v-icon small class="mt-n1">
                                                    mdi-arrow-right-box
                                                </v-icon>
                                                Make
                                            </v-btn>
                                        </template>
                                    </template>

                                </DxDataGrid>

                            </v-col>
                        </v-row>
                    </template>
                </i-card-vertical>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { DxDataGrid, DxColumn } from 'devextreme-vue/data-grid'
import notify from 'devextreme/ui/notify'
import ICardVertical from '@/components/common/iCardVertical.vue'
import iCardTop from '@/components/common/iCardTop.vue'
import baseview from '@/components/base/baseview.vue'
import BaseDataGrid from '@/components/base/BaseDataGrid.vue'
import { getCmChildCode } from '@/api/system/cmCodeManage'
import { getRequestList, goReceive } from '@/api/view/hycot/common/common.js'


export default {
    name: 'hycot401',
    mixins: [baseview, BaseDataGrid],
    components: {
        ICardVertical,
        iCardTop,
        DxDataGrid,
        DxColumn
    },
    data() {
        return {
            hycot401Ref: 'hycot401Ref',
            menuTitle: this.$route.meta.title,
            dataList: [],
            matList: [],
            selectedMat: null,
            rcvList: [],
            selectedRcv: null,
            sbmList: [],
            selectedSbm: null
        }
    },
    computed: {
        gridInstance() {
            console.log('gridInstance', this.GetDataGrid(this.hycot401Ref))
            return this.GetDataGrid(this.hycot401Ref)
        }
    },
    methods: {
        async bindingCombo() {
            await this.bindingMat()
            await this.bindingRcv()
            await this.bindingSbm()
        },
        /*---@@@ Material Division---*/
        async bindingMat() {
            await getCmChildCode({
                code: '',
                codegr: 'HYCOT',
                prtCode: 'MAT_DIV1',
                userFlag: 'Y'
            }).then(res => {
                // console.log('res', res)

                this.matList = res.list
                this.matList.unshift({
                    code: '',
                    codeName: 'All'
                })
                this.selectedMat = this.matList[0]

            })
        },
        /*---@@@ Receive---*/
        async bindingRcv() {
            await getCmChildCode({
                code: '',
                codegr: 'HYCOT',
                prtCode: 'RCV_DIV',
                userFlag: 'Y'
            }).then(res => {
                // console.log('res', res)

                this.rcvList = res.list
                this.rcvList.unshift({
                    code: '',
                    codeName: 'All'
                })
                this.selectedRcv = this.rcvList[0]
            })
        },
        /*---@@@ Submit---*/
        async bindingSbm() {
            await getCmChildCode({
                code: '',
                codegr: 'HYCOT',
                prtCode: 'SBM_DIV',
                userFlag: 'Y'
            }).then(res => {
                // console.log('res', res)

                this.sbmList = res.list
                this.sbmList.unshift({
                    code: '',
                    codeName: 'All'
                })
                this.selectedSbm = this.sbmList[0]
            })
        },

        async btnSearch() {
            this.dataList = []
            this.dataList2 = []
            this.openLoading('searching')

            const param = {
                makerCd: this.$store.state.user.makerCd,
                quotStep: 'C',
                receiveYn: this.selectedRcv.code,
                submitYn: this.selectedSbm.code,
                matlDiv: this.selectedMat.code,
                userId: this.$store.state.user.userId,
            }

            await getRequestList(param).then(res => {
                // console.log('res', res)

                this.dataList = res.list
            }).finally(() => {
                this.endLoading()
            })

        },

        cellPrepared(e) {
            if (e.rowType === 'data') {
                e.cellElement.style.padding = '1px 8px'
            }
        },

        /*.....goDetail..... */
        goDetail(data) {
            const quotNo = data.data.quotNo
            const quotGbn = quotNo.substr(0, 3)

            // console.log('quotNo', quotNo)
            // console.log('quotGbn', quotGbn)

            if (quotGbn === 'QTL') {
                this.$router.push({
                    name: 'hycot402',
                    params: {
                        quotNo: quotNo
                    }
                })
            } else {
                this.$router.push({
                    name: 'hycot403',
                    params: {
                        quotNo: quotNo
                    }
                })
            }
        },

        receiveQuot(data) {
            // console.log('data', data)

            this.vToastifyPrompt(
                this.$t('Do you want to receive the Bidding Request?'),
                'info',
                current => {
                    this.openLoading('searching')

                    const param = {
                        quotNo: data.quotNo,
                        makerCd: this.$store.state.user.makerCd
                    }

                    console.log('param', param)

                    goReceive(param).then(res => {
                        // console.log('res', res)

                        const msg = res.body
                        if (msg === 'OK') {
                            notify(this.$t('Receipt Bidding is completed.'), 'success', 3000)

                            this.btnSearch()
                        } else {
                            this.vToastify(this.$t(msg), 'warn')
                        }
                    }).catch(error => {
                        this.vToastify(error, 'warn')
                    }).finally(() => {
                        this.endLoading()
                    })
                },
                null,
                true
            )
        }
    },
    async mounted() {
        await this.bindingCombo()
        await this.btnSearch()
    }
}
</script>

<style lang="scss" scoped>
.hycot401-main {
    .subTitle {
        font-weight: bold;
        color: black;
    }

    .grd-btn {
        text-transform: unset !important;
        font-weight: bold;
        // height: 16px !important;

        :hover {
            color: #4980BC;
        }
    }
}
</style>